<template>
  <CContainer>
    <CRow class="justify-content-center mt-4">
      <CCol md="8">
        <div
          class="d-flex flex-column align-items-center justify-content-center mb-2 max-w-500 m-auto"
        >
          <div class="d-flex flex-column">
            <h1 class="text-center">
              Auto Pass
              <HelpCenterButton classes="ms-2" content-key="auto_pass" />
            </h1>
            <p class="text-value-sm">Select multiple rooms</p>
          </div>
          <div class="w-100">
            <CAlert
              v-if="reqResponse.message"
              class="mt-4 w-100"
              :color="reqResponse.type"
              :show="!!reqResponse.message"
              close-button
            >
              {{ reqResponse.message }}
            </CAlert>
            <LazyLoadSelect
              :classes="'mb-3'"
              :is-multiple="true"
              :only-basic-data="true"
              :force-clear-cache="roomsUpdated"
              :selected="form.rooms"
              type="locations"
              placeholder="Select location"
              @changed="
                (value) => {
                  setRooms(value)
                }
              "
            >
              <template #footer>
                <div
                  v-if="reqResponse.errors['room_id']"
                  class="invalid-feedback"
                >
                  {{ reqResponse.errors["room_id"][0] }}
                </div>
              </template>
            </LazyLoadSelect>
          </div>

          <div class="d-flex justify-content-center mt-4" @click="submit()">
            <CLoadingButton
              :spinner="isLoading"
              :disabled="isLoading"
              :loading="isLoading"
              class="me-2 btn bg-gradient-blue text-white"
            >
              Submit
            </CLoadingButton>
          </div>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { mapGetters } from "vuex"
import HelpCenterButton from "../HelpCenterButton"
import LazyLoadSelect from "@/components/LazyLoadSelect.vue"

export default {
  name: "AutoPassForm",
  components: { HelpCenterButton, LazyLoadSelect },
  data() {
    return {
      isLoading: false,
      form: {
        rooms: []
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      }
    }
  },
  computed: {
    ...mapGetters({
      autoPassLimits: "rooms/autoPassLimits",
      roomsUpdated: "rooms/roomsUpdated"
    })
  },
  created() {
    this.$store.dispatch("rooms/getAutoPassLimit").then((response) => {
      const data = response.data.data
      if (data.auto_pass_rooms && data.auto_pass_rooms.length) {
        this.setAutoPassLimitData(data)
      }
    })
  },
  methods: {
    submit() {
      this.resetResponseMessages()
      this.isLoading = true
      this.$store
        .dispatch("rooms/setAutoPassLimit", {
          autopass_rooms: this.form.rooms.map((el) => el.value.id)
        })
        .then(() => {
          this.setSuccessResponse(
            "Success! The Auto Room(s) was created successfully."
          )
          this.isLoading = false
          setTimeout(() => {
            this.resetResponseMessages()
          }, 1000)
        })
        .catch((err) => {
          const response = err.response.data
          this.setErrorResponse(response.message, response.errors)
          this.isLoading = false
        })
    },
    setAutoPassLimitData(data) {
      data.auto_pass_rooms.forEach((el) => {
        this.form.rooms.push({
          value: {
            id: el.room_id,
            type: "App\\Models\\Room"
          },
          label: el.room.name
        })
      })
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: this.generateErrorMessage(message, errors),
        errors: errors ? errors : {}
      }
    },
    generateErrorMessage(message, errors) {
      if (!message) {
        return "Someting went wrong!"
      }

      const inactiveRooms = this.getInactiveRooms(errors)

      if (inactiveRooms.length > 0) {
        return `The following rooms are inactive and cannot be assigned as auto pass: ${inactiveRooms.join(
          ", "
        )}`
      }

      return message
    },
    setRooms(value) {
      this.form.rooms = value
      //to not clear the cache of search endpoint in lazyloading after choosing one or more options
      this.$store.commit("rooms/SET_ROOMS_UPDATED", false)
    },
    getInactiveRooms(errors) {
      const rooms = []

      for (const fieldName in errors) {
        if (!fieldName.startsWith("autopass_rooms.")) {
          continue
        }

        if (
          Array.isArray(errors[fieldName]) &&
          errors[fieldName].length > 0 &&
          errors[fieldName][0].inactive
        ) {
          rooms.push(errors[fieldName][0].name)
        }
      }

      return rooms
    }
  }
}
</script>
